import React from 'react';
import { graphql } from 'gatsby';
import { CareersFeed as CareersFeedComponent } from '../../CareersFeed';

export const CareersFeed = ({ data, ...rest }) => <CareersFeedComponent {...data} {...rest} />;

export const CareersFeedQuery = graphql`
  fragment CareersFeed on KFH_UmbracoCareersFeedComponentType {
    title
    backgroundColour
    jobs {
      name
      relativeUrl
      location
      employmentType
      maxSalary
      minSalary
    }
  }
`;
